module.exports = (Type) -> (val, message = "assertion failed") ->
  if !val
    throw new Type(message)
  return
